import { APP } from '../../redux/constants/app.constants';

export const ALERT_DIALOG = `${APP}/ALERT_DIALOG`;

export const SHOW_ALERT = `${ALERT_DIALOG}/SHOW_ALERT`;